import React from 'react';
import type { BombiixIconProps } from './types';

/**
 * Bombiix AI file-type badge — document outline with orange "AI" chip.
 * Multi-colour by design (file-type semantic); does not honour currentColor.
 */
const AiFileIcon: React.FC<BombiixIconProps> = ({ size = 20, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...rest}>
    <path
      d="M11.7002 7.55856H14.3641L11.7002 4.66737V7.55856ZM15.9004 15.2096C15.9004 15.6844 15.7262 16.1396 15.417 16.4754C15.1076 16.8112 14.6874 17 14.2499 17H7.05005C6.61256 16.9999 6.19313 16.8111 5.88378 16.4754C5.57444 16.1396 5.40039 15.6844 5.40039 15.2096V4.79042C5.40047 4.3156 5.57442 3.86038 5.88378 3.52463C6.19313 3.18888 6.61256 3.00008 7.05005 3H11.2502C11.3696 3 11.484 3.05149 11.5684 3.14308L15.7686 7.70164C15.8528 7.7932 15.9004 7.91757 15.9004 8.04694V15.2096ZM6.30037 15.2096C6.30037 15.4254 6.37953 15.6321 6.52009 15.7848C6.66067 15.9373 6.85125 16.0231 7.05005 16.0232H14.2499C14.4488 16.0232 14.64 15.9374 14.7807 15.7848C14.9212 15.6321 15.0004 15.4253 15.0004 15.2096V8.53533H11.2502C11.0018 8.53533 10.8004 8.31652 10.8002 8.04694V3.97677H7.05005C6.85125 3.97685 6.66067 4.06266 6.52009 4.21523C6.37951 4.36781 6.30044 4.57466 6.30037 4.79042V15.2096Z"
      fill="#3C3C3C"
    />
    <rect x="4" y="10" width="5.4" height="4.1" rx="0.7" fill="#FFE1CB" />
    <rect x="4" y="10" width="5.4" height="4.1" rx="0.7" fill="#FFB882" />
    <path
      d="M6.6403 12.6168H5.7233L5.5763 13.0508H4.9498L5.8388 10.5938H6.5318L7.4208 13.0508H6.7873L6.6403 12.6168ZM6.4863 12.1548L6.1818 11.2553L5.8808 12.1548H6.4863ZM8.28987 10.5938V13.0508H7.69137V10.5938H8.28987Z"
      fill="white"
    />
  </svg>
);

export default AiFileIcon;
